import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useCart } from '../CartContext';
import { toast } from 'react-toastify';

const API = process.env.REACT_APP_API_URL;

function ProductCard({ product, presetDesigns }) {
  const { addToCart, cart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [selectedDesign, setSelectedDesign] = useState('');
  const [showDesigns, setShowDesigns] = useState(false);

const handleAdd = () => {
    if (product.personalisation_enabled && !selectedDesign) {
      toast.error('Please select a design for this item.');
      return;
    }
    // Check how many are already in the cart
    const currentInCart = cart.reduce((sum, i) => 
      i.product.id === product.id ? sum + i.quantity : sum, 0);
    if (currentInCart + quantity > product.stock_quantity) {
      toast.error(`Only ${product.stock_quantity} available. You already have ${currentInCart} in your basket.`);
      return;
    }
    addToCart(product, quantity,
      null,
      product.personalisation_enabled ? selectedDesign : null
    );
    toast.success(`${product.name} added to basket!`);
    setSelectedDesign('');
    setQuantity(1);
    setShowDesigns(false);
  };

  return (
    <div style={{
      border: '1px solid #e0e0e0', borderRadius: '12px', overflow: 'hidden',
      display: 'flex', flexDirection: 'column', background: '#fff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    }}>
      {product.image_url
        ? <img src={product.image_url} alt={product.name}
            style={{ width: '100%', height: '220px', objectFit: 'cover' }} />
        : <div style={{ width: '100%', height: '220px', background: '#f5f5f5',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '48px' }}>🔑</div>
      }
      <div style={{ padding: '16px', flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <h3 style={{ margin: 0, fontSize: '18px' }}>{product.name}</h3>
        <p style={{ margin: 0, color: '#666', fontSize: '14px', flex: 1 }}>{product.description}</p>
        <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>£{product.base_price.toFixed(2)}</p>

        {product.personalisation_enabled && (
          <div>
            <button onClick={() => setShowDesigns(!showDesigns)}
              style={{ width: '100%', padding: '8px', background: '#f0f0f0',
                border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer', marginBottom: '8px' }}>
              {selectedDesign
                ? `Design: ${presetDesigns.find(d => d.id === selectedDesign)?.name}`
                : '🎨 Choose a design'}
            </button>
            {showDesigns && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '8px', marginBottom: '8px', maxHeight: '200px', overflowY: 'auto' }}>
                {presetDesigns.map(d => (
                  <div key={d.id} onClick={() => { setSelectedDesign(d.id); setShowDesigns(false); }}
                    style={{
                      border: selectedDesign === d.id ? '2px solid #111' : '1px solid #ddd',
                      borderRadius: '6px', padding: '6px', cursor: 'pointer',
                      textAlign: 'center', fontSize: '12px', background: '#fafafa',
                    }}>
                    {d.image_url
                      ? <img src={d.image_url} alt={d.name}
                          style={{ width: '100%', height: '50px', objectFit: 'contain' }} />
                      : <div style={{ height: '50px', display: 'flex', alignItems: 'center',
                          justifyContent: 'center', fontSize: '24px' }}>🖼️</div>
                    }
                    <div>{d.name}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ddd',
            borderRadius: '6px', overflow: 'hidden' }}>
            <button onClick={() => setQuantity(q => Math.max(1, q - 1))}
              style={{ padding: '6px 12px', border: 'none', background: '#f5f5f5',
                cursor: 'pointer', fontSize: '16px' }}>−</button>
            <span style={{ padding: '6px 12px', minWidth: '30px', textAlign: 'center' }}>{quantity}</span>
            <button onClick={() => setQuantity(q => q + 1)}
              style={{ padding: '6px 12px', border: 'none', background: '#f5f5f5',
                cursor: 'pointer', fontSize: '16px' }}>+</button>
          </div>
          <button onClick={handleAdd}
            style={{ flex: 1, padding: '8px', background: '#111', color: '#fff',
              border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '15px' }}>
            Add to Basket
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  const [products, setProducts] = useState([]);
  const [presetDesigns, setPresetDesigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/products`),
      axios.get(`${API}/preset-designs`),
    ]).then(([prodRes, designRes]) => {
      setProducts(prodRes.data);
      setPresetDesigns(designRes.data);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '80px', fontFamily: 'sans-serif' }}>
      Loading products...
    </div>
  );

  return (
    <div style={{ fontFamily: 'sans-serif', maxWidth: '1100px', margin: '0 auto', padding: '32px 20px' }}>

      {products.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#999' }}>
          <p style={{ fontSize: '48px' }}>🔑</p>
          <p>Products coming soon — check back shortly!</p>
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '24px',
        }}>
          {products.map(p => (
            <ProductCard key={p.id} product={p} presetDesigns={presetDesigns} />
          ))}
        </div>
      )}
    </div>
  );
}
